import { Component, OnInit, Input, ViewChildren, SimpleChanges } from '@angular/core';

import { TipoUrlEnum } from '../../utilidades.index';
import { ConversorBytesPipe } from '../../utilidades.pipes.index';
import { RespuestaModel } from '../../utilidades.modelos.index';
import { UtilidadesService } from '../../utilidades.servicios.index';

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
	selector: 'file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: [
		'./file-upload.component.scss'
	]
})
export class FileUploadComponent implements OnInit {

	public Configuracion: Configuracion;

	//Url de la cual va a recibir toda la configuración del file upload.
	@Input('UrlConfiguracion') UrlConfiguracion: string = "";

	//Obtiene la lista de los archivos seleccionados.
	public Archivos: Archivo[] = [];

	private TokenDeConfiguracion: string = "";

	@ViewChildren("FileUpload") FileUpload;

	constructor(
		private Utilidades: UtilidadesService
	) {
		this.Configuracion = new Configuracion();
	}

	ngOnInit() {
		//this.CargarConfiguracion();
	}

	ngOnChanges(cambios: SimpleChanges) {
		for (let cambio in cambios) {
			switch (cambio) {
				case "UrlConfiguracion":
					this.CargarConfiguracion();
					break;
			}
		}
	}

	SeleccionarArchivos(): void {
		this.FileUpload.first.nativeElement.click();
	}

	QuitarArchivo(indice: number): void {
		let Archivo: Archivo = this.Archivos[indice];

		if (Archivo) {
			this.Utilidades.CuadroDeConfirmacion("Advertencia!", `¿Desea eliminar el archivo <b>${Archivo.NombreDeArchivo}</b>?`, () => {
				if (Archivo.ArchivoTMP) {
					let Form: FormData = new FormData();

					Form.append("Datos", this.TokenDeConfiguracion);
					Form.append("IdArchivo", Archivo.ArchivoTMP.IdArchivo.toString());

					Archivo.Eliminando = true;
					this.Utilidades.PostFormulario(this.Configuracion.ServicioEliminar, Form, true).subscribe(rta => {
						Archivo.Eliminando = false;
						if (rta.CantidadDeErrores == 0) {
							this.Archivos.splice(indice, 1);
						}
						else {
							this.Utilidades.CuadroDeMensaje("Error!", rta.Error);
						}
					});
				}
				else {
					this.Archivos.splice(indice, 1);
				}
			});
		}		
	}

	onSeleccionarArchivos(evento: File[]): void {
		for (let f of evento) {
			let a: Archivo = new Archivo();

			let Errores: string[] = this.ValidarArchivo(f);
			if (Errores.length > 0) {
				a.Errores = Errores;
				a.Subir = false
			}
			else {
				a.Subir = true;
			}

			a.Archivo = f;

			//Valido que el archivo no exista.
			if (this.Archivos.filter(archivo => archivo.NombreDeArchivo == f.name).length == 0) {
				this.Archivos.push(a);

				if (a.Subir) {
					a.SubirArchivo(this.Configuracion.ServicioSubir, this.TokenDeConfiguracion, this.Utilidades);
				}
			}
			else {
				this.Utilidades.CuadroDeMensaje("Error!", ["- El archivo <b>" + f.name + "</b> ya fue seleccionado."]);
			}		
		}
	}

	get ObtenerEtiqueta(): string {
		let Aux: Archivo[] = this.Archivos.filter(a => a.Subir == true);

		switch (Aux.length) {
			case 0:
				return "";

			case 1:
				return Aux[0].Archivo.name;

			default:
				return Aux.length + " archivos";
		}
	}

	get EtiquetaBotonSubirArchivos(): string {
		let Rta: string = "";

		if (this.Configuracion.CantidadDeArchivos == 0) {
			Rta = "Seleccionar archivos";
		}
		else if (this.Configuracion.CantidadDeArchivos == 1) {
			Rta = "Seleccione un archivo";
		}
		else {
			Rta = "Seleccione hasta " + this.Configuracion.CantidadDeArchivos + " archivos";
		}

		return Rta;
	}

	private ValidarArchivo(f: File): string[] {
		let Errores: string[] = [];

		//Valido si está permitida la extención.
		if (this.Configuracion.ExtencionesPermitidas) {
			let Extenciones: string[] = this.Configuracion.ExtencionesPermitidas.split("|");
			let Ext: string = this.ObtenerExtencion(f.name).toLowerCase();

			//busco si la extención del archivo esta en la lista de permitidos.
			if (Extenciones.filter(e => e.toLowerCase() == Ext).length == 0) {
				Errores.push("- El tipo de archivo no está permitido. Los tipos permitidos son " + Extenciones.join(", ") + ".");
			}
		}

		//Valido el tamaño del archivo.
		if (this.Configuracion.TamanioMaximo) {
			if (f.size > this.Configuracion.TamanioMaximo) {
				let Pipe = new ConversorBytesPipe();

				Errores.push("- El archivo es más grande de lo permitido. El tamaño máximo es de " + Pipe.transform(this.Configuracion.TamanioMaximo));
			}
		}

		//Valido la cantidad máxima de archivos.
		if (this.Configuracion.CantidadDeArchivos > 0) {
			if (this.Archivos.length >= this.Configuracion.CantidadDeArchivos) {
				Errores.push("- Se ha alcanzado el límite de archivos.");
			}
		}

		return Errores;
	}

	private ObtenerExtencion(nombre: string): string {
		var ext = /^.+\.([^.]+)$/.exec(nombre);
		return ext == null ? "" : ext[1];
	}

	private CargarConfiguracion() {
		//Valido si tiene una url de dónde tomar la configuración.
		if (this.UrlConfiguracion) {
			//Llamo al servicio para obtener la configuración del file upload.
			this.Utilidades.Get(this.UrlConfiguracion, TipoUrlEnum.Absoluta).subscribe(rta => {
				if (rta.Resultado) {
					const JWT = new JwtHelperService();

					//Valido el token de configuración.
					let Config = JWT.decodeToken(rta.Resultado);

					//Si el token es correcto, ahora Config tiene toda la configuración del file upload.
					if (Config) {
						this.Configuracion = Config;

						this.TokenDeConfiguracion = rta.Resultado;

						//Si hay una url para listar archivos pendientes
						if (this.Configuracion.ServicioLista) {
							let Formulario: FormData = new FormData();
							Formulario.append("Datos", this.TokenDeConfiguracion);

							this.Utilidades.PostFormulario(this.Configuracion.ServicioLista, Formulario, true).subscribe(a => {
								if (a.CantidadDeErrores == 0) {
									//Si hay archivos, pregunto si quiere usarlos, si no los elimino.
									if ((<ArchivoTMP[]>a.Resultado).length > 0) {
										this.Utilidades.CuadroDeConfirmacion("Advertencia!", "Hay archivos pendientes ¿Desea utilizarlos?",
											() => {
												(<ArchivoTMP[]>a.Resultado).forEach(arc => {
													let Arc = new Archivo();
													Arc.ArchivoTMP = arc;

													this.Archivos.push(Arc);
												});
											},
											() => {
												//por aca tiene que eliminar los archivos.
												let Datos: FormData = new FormData();
												Datos.append("Datos", this.TokenDeConfiguracion);

												this.Utilidades.PostFormulario(this.Configuracion.ServicioBorrarTemporales, Datos, true).subscribe(e => {
													if (e.CantidadDeErrores > 0) {
														this.Utilidades.CuadroDeMensaje("Error", e.Error);
													}
												});
											});
									}
								}
								else {
									this.Utilidades.CuadroDeMensaje("Error!", a.Error);
								}
							});
						}
					}
				}
			});
		}
	}
}

class Archivo {
	public Archivo: File;
	public ArchivoTMP: ArchivoTMP;
	public Errores: string[] = [];
	public Subir: boolean = false;
	public Respuesta: RespuestaModel = new RespuestaModel();
	public Eliminando: boolean = false;

	//Formulario para subir los archivos.
	private FormData: FormData = new FormData();

	//Objeto que hace la llamada al servicio.
	private xhr: XMLHttpRequest = new XMLHttpRequest();

	//Objeto que me informa del progreso.
	private _progreso: BehaviorSubject<number> = new BehaviorSubject(0);

	//Obtengo el progreso como un observable.
	get Progreso(): Observable<number> {
		return this._progreso.asObservable();
	}

	get NombreDeArchivo(): string {
		if (this.ArchivoTMP) {
			return `${this.ArchivoTMP.Descripcion}.${this.ArchivoTMP.Extencion}`;
		}
		else {
			if (this.Archivo) {
				return this.Archivo.name;
			}
			else {
				return "No hay archivo";
			}
		}
	}

	public SubirArchivo(urlDesdeRaiz: string, tokenDeConfiguracion: string, utilidades: UtilidadesService): void {
		//Instancio XHR.
		this.xhr = new XMLHttpRequest();
		this.xhr.responseType = 'json';

		let Url: string = environment.UrlRoot + urlDesdeRaiz;
			
		this.FormData.append('file', this.Archivo, this.Archivo.name);

		if (tokenDeConfiguracion) {
			this.FormData.append('Datos', tokenDeConfiguracion);
		}

		//Ejecuto cada vez que cambia el estado.
		this.xhr.onreadystatechange = () => {

			/*
				0	UNSENT				Client has been created. open() not called yet.
				1	OPENED				open() has been called.
				2	HEADERS_RECEIVED	send() has been called, and headers and status are available.
				3	LOADING				Downloading; responseText holds partial data.
				4	DONE				The operation is complete.
			*/

			//Si el estado es 4
			if (this.xhr.readyState === 4) {
				switch (this.xhr.status)
				{
					case 200:
						this.Respuesta = (<RespuestaModel>this.xhr.response);

						if (this.Respuesta.CantidadDeErrores == 0) {
							this.ArchivoTMP = this.Respuesta.Resultado;
						}
						else {
							this.Errores = this.Respuesta.Error;
						}

						break;

					case 404:
						this.Errores.push("- \"" + Url + "\" no existe.");
						break;

					case 401:
						this.Errores.push("- No tiene permisos para subir el archivo.");
						break;

					default:
						this.Errores.push(this.xhr.statusText);
						break;
				}
				
			}
		};

		// Emit current progress in percents
		this.xhr.upload.onprogress = (event: ProgressEvent) => {
			this._progreso.next(Math.round((event.loaded / event.total) * 100));
		};
		
		this.xhr.open('POST', Url, true);
		if (utilidades) {
			this.xhr.setRequestHeader("AyC_Token", utilidades.ObtenerToken());
		}
		this.xhr.send(this.FormData);
	}

	constructor() { }
}

export class Configuracion {
	constructor() { }

	public Multiple: boolean = true;
	public ServicioSubir: string = "/Archivos/API/Subir";
	public ServicioLista: string = "/Archivos/API/Lista";
	public ServicioEliminar: string = "/Archivos/API/Eliminar";
	public ServicioBorrarTemporales: string = "/Archivos/API/BorrarTemporales";
	public ServicioGuardar: string = "/Archivos/API/Guardar";
	public CantidadDeArchivos: number = 0;
	public ExtencionesPermitidas: string = "";
	public TamanioMaximo: number = 0;
	public exp: number = 0;
	public IdSistema: number = 0;
	public IdGrupo: number = 0;
	public Grupo: string = "";
	public IdObjeto: string = "";
}

class ArchivoTMP {
	constructor() { }

	public IdArchivo: number = 0;
	public IdSistema: number = 0;
	public IdGrupo: number = 0;
	public IdObjeto: string = "";
	public Fecha: Date = new Date(1900, 1, 1);
    public Autor: string = "";
    public Descripcion: string = "";
    public Extencion: string = "";
	public Mostrar: boolean = true;
}